import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * `/onboarding` — first-run wizard index. Redirects the admin to
 * the first pending step (or `/` when already complete). Page body
 * lazy-loaded to keep the wizard out of the eager bundle.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/onboarding",
	component: lazyRouteComponent(() => import("./index.page")),
})
